
import { useSelector, useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showNestedModal } from "../../../features/modal/modalSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"


const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1300px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .content{
            height: auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 10px 40px;
            margin: 20px 0;
            max-height: 700px;
            overflow: auto;
            width: 100%;

            img{
                width: 100%;
            }

        }

        .btn-container{
            width: 100%;
            padding: 20px;
            padding-bottom: 30px;
            display: flex;
            justify-content: center;
        }
    }
`

const ShipmentIrsaliyeWideModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {belgeDataSingleItem} = useSelector(state => state.loadList)
    const { lockScroll, unlockScroll } = useScrollLock();

  return (
    <Container onClick={() => dispatch(showNestedModal(null))}>
        <div className="modal"  onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <img src={`${process.env.REACT_APP_API_IMG_URI}${belgeDataSingleItem.documentOfRoutePoint}`} alt="" />
            </div>
            <div className="btn-container">
                <Btn bgColor="transparent" color="#E85446" width={"260px"} handleClick={()=> dispatch(showNestedModal(null))} borderColor="#E85446">Geri Dön</Btn>
            </div>
        </div>
    </Container>
  )
}

export default ShipmentIrsaliyeWideModal
